import React, { useEffect, useState } from 'react';
import { auth, db } from '../FirebaseComp/firebase'; // Ensure correct path
import { doc, getDoc } from 'firebase/firestore';

import './userprofile.css';

function UserProfile() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      const currentUser = auth.currentUser;
      if (currentUser) {
        try {
          const userRef = doc(db, 'users', currentUser.uid);
          const docSnap = await getDoc(userRef);
          if (docSnap.exists()) {
            setUser(docSnap.data());
          } else {
            console.log("No such document!");
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      }
    };
    fetchUserData();
  }, []);

  return (
    <>
            <section className="hero">
              <div className="hero-image">
                  <img src="/round-logo.png" alt="conference" />
                </div>
                <div className="hero-content">
                <h1>Eye Care Clinic & Optical</h1>
                <p>
                Providing trusted eye clinic and quality optical services since 2007, 
                our clinic is committed to enhancing eye health and improving lives through 
                expert care and advanced solutions.
                </p>

                </div>
            </section>

    <div className="user-profile-container">
    <img src="/user.jpg" alt="User Profile" />
      <h2 className="user-profile-header">My Profile</h2>
      {user ? (
        <>
          <div className="user-info">
            <p className="user-info-item"><strong>Name:</strong> {user.name}</p>
            <p className="user-info-item"><strong>Email:</strong> {user.email}</p>
            <p className="user-info-item"><strong>Contact No:</strong> {user.contactNo}</p>
            {/* <p className="user-info-item"><strong>Country:</strong> {user.country}</p> */}

          </div>
        </>
      ) : (
        <p>Hello,...</p>
      )}
    </div>
    </>
  );
}

export default UserProfile;
